export default "__VITE_ASSET__PA_ctW_k__"